import React from "react";

// マイページ右カラムに表示する各セクションコンポーネント
import PaymentDetails from "./components/PaymentDetails";
import TransactionHistory from "./components/TransactionHistory";
import BankAccount from "./components/BankAccount";
import Notification from "./components/Notification";
import Role from "./components/Role";
import OfferConditions from "./components/OfferConditions";
import PersonalInformation from "./components/PersonalInformation";
import FollowersAndFollowing from "./components/FollowersAndFollowing";
import EmailPassword from "./components/EmailPassword";
import MCP from "./components/MCP";
import DocumentSeal from "./components/DocumentSeal";

const rightColumnComponents = {
  paymentDetails: <PaymentDetails />,
  transactionHistory: <TransactionHistory />,
  bankAccount: <BankAccount />,
  notification: <Notification />,
  role: <Role />,
  offerConditions: <OfferConditions />,
  followersAndFollowing: <FollowersAndFollowing />,
  emailPassword: <EmailPassword />,
  personalInformation: <PersonalInformation />,
  MCP: <MCP />,
  documentSeal: <DocumentSeal />,
};

export default rightColumnComponents;
